import ErrorBoundary from '@components/Error/ErrorBoundary'
import SideBar from '@components/SideBar'
import DialogProvider from '@ui-components/Dialog/provider'
import { Suspense } from 'react'

const CommonLayout = ({ children }) => {
  return (
    <div className="grid grid-rows-1 h-100 min-h-screen bg-oxford-gray-50 print:bg-white print:h-auto">
      <Suspense fallback={null}>
        <ErrorBoundary>
          <SideBar />
          <div className="pl-9 print:pl-0 mx-auto w-screen h-100">
            {children}
          </div>
        </ErrorBoundary>
      </Suspense>
    </div>
  )
}

const LayoutRoot = ({ children, CustomLayout }) => {
  const Layout = CustomLayout || CommonLayout
  return (
    <div className="font-sans layout-root">
      <DialogProvider>
        <Suspense fallback={null}>
          <Layout>{children}</Layout>
        </Suspense>
      </DialogProvider>
    </div>
  )
}

export default LayoutRoot
